<template>
  <div class="screen" :class="{activeBj:this.currentSocketData.length>0}">
    <!-- <button ref="printButton"  @click="playVoice">播放</button> -->
    <div class="header">
      <div class="title-h-1">{{ titleData.siteName ? titleData.siteName : titleData.username }}</div>
      <div class="title-h-2">（大数据云平台）</div>
    </div>
    <div class="mainScreen">
      <div class="left">
        <div class="left-item-1">
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">总人数</span> <span class="des2">（人）</span>
            </div>
            <div class="left-item-1-num">{{ tongji.totalCount }}</div>
          </div>
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">在线数</span> <span class="des2">（人）</span>
            </div>
            <div class="left-item-1-num">{{ tongji.onlineCount }}</div>
          </div>
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">离线数</span> <span class="des2">（人）</span>
            </div>
            <div class="left-item-1-num active">{{ tongji.offlineCount }}</div>
         
          </div>
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">办理人数</span> <span class="des2">（人）</span>
            </div>
            <div class="left-item-1-num active">{{this.titleData.userType=="school"?tongji.activeTotalCount:tongji.activeTotalCount}}</div>
         
          </div>
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">{{this.titleData.userType=="school"?"学校数量":"总激活数"}}</span>
              <span class="des2">{{unit}}</span>
            </div>
            <div class="left-item-1-num">{{this.titleData.userType=="school"?tongji.schoolCount:tongji.activeTotalCount}}</div>
          </div>
          <!-- <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">{{this.titleData.userType=="school"?"学校数量":"总激活数"}}</span>
              <span class="des2">{{unit}}</span>
            </div>
            <div class="left-item-1-num">{{this.titleData.userType=="school"?tongji.schoolCount:tongji.activeTotalCount}}</div>
          </div> -->
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">{{this.titleData.userType=="school"?"班级数量":"7日激活数(个)"}}</span>
            
              <!-- <span class="des2">{{unit}}</span> -->
            </div>
            <div class="left-item-1-num">{{this.titleData.userType=="school"?tongji.classCount:tongji.weekTotalCount}}</div>
          
          </div>
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">7日内新增用户</span>
              <!-- <span class="des2">（个）</span> -->
              <p class="des2" v-if="this.titleData.userType=='school'">(个)</p>
            </div>
            <div class="left-item-1-num" style="padding-top: 0px">150</div>
          </div>
          <div class="left-item-1-i">
            <div class="left-item-1-title">
              <span class="des1">安全守护</span>
              <span class="des2">（天）</span>
              <p class="des2" v-if="this.titleData.userType=='school'">守护校园天数</p>
            </div>
            <div class="left-item-1-num" style="padding-top: 0px">{{ tongji.safetyGuardCount }}</div>
          </div>
        </div>
        
        <div class="left-item-2 card">
          <div class="com-title">SOS报警</div>
          <div id="leftChart"></div>
        </div>
        
        <div class="left-item-3 card">
          <div class="com-title">SOS报警明细</div>
          <div class="scrollData">
            <vue3-seamless-scroll
              :hover="true"
              :list="sosList"
              :step="0.4"
              :wheel="true"
              :isWatch="true"
              :limitScrollNum="6"
            >
              <p v-for="(item, index) in sosList" :key="index">
                <!-- // " 2024-08-19 22:07:25SOS紧急求助!。|学生姓名：张毅", -->
                {{ item.createDate }}
                {{ item.description }}
                |
               学生姓名 {{ item.username }}
                </p>
            </vue3-seamless-scroll>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="middle-item1">
          <div class="middle-item1-1">
            <div class="middle-title">今日天气</div>
            <div class="m-content-1">
              <ScreenClock />
              <div class="tqicon">
                <img src="../../assets/screen/tianqi.png" alt="" srcset="">
              </div>
              <div class="des">
                <!-- <p>{{tianqiData.length>0?tianqiData[0].dayWeather:""}}</p>
                <p>{{tianqiData.length>0?tianqiData[0].nightTemp:""}}~{{tianqiData.length>0?tianqiData[0].dayTemp:""}}</p>
                <p>{{cityInfo.province}} {{cityInfo.city}}</p> -->
                <p>{{currentTianqi.weather}}</p>
                <p>{{currentTianqi.temp}}</p>
                <p>{{currentTianqi.city}}</p>
              </div>
            </div>
          </div>
          <div class="middle-item1-2">
            <div class="middle-title">{{this.titleData.userType=="school"?"当前学校":"当前组织"}}</div>
            <div class="m-content-2">
              <div>{{ formatName(currentSchool) }}</div>
              <img src="../../assets/screen/select.png" alt="" />
            </div>
          </div>
        </div>
        <div class="middle-item2 card">
          <div class="com-title">{{this.titleData.userType=="oldPeople"?"在线终端定位":"在线学生定位"}}</div>
          <div id="container"></div>
        </div>
      </div>
      <div class="right">
        <div class="right-item-1 card">
          <div class="com-title">{{this.titleData.userType=="school"?"全部学校":"全部组织"}}</div>
          <div class="scrollData">
            <vue3-seamless-scroll
              :hover="true"
              :list="schoolList"
              :step="0.4"
              :wheel="true"
              :isWatch="true"
              :limitScrollNum="6"
            >
              <p v-for="(item, index) in schoolList" :key="item.id" :class="{ active: currentSchool.id == item.id }" @click="handleSelectSchool(item)">{{  formatName(item) }}</p>
            </vue3-seamless-scroll>
          </div>
        </div>
        <div class="right-item-2 card">
          <div class="com-title">水域报警</div>
          <div id="rightChart">

          </div>
        </div>
        <div class="right-item-3 card">
          <div class="com-title">危险水域报警</div>
          <div class="scrollData">
            <vue3-seamless-scroll
              :hover="true"
              :list="waterList"
              :step="0.4"
              :wheel="true"
              :isWatch="true"
              :limitScrollNum="6"
            >
              <p v-for="(item, index) in waterList" :key="index">
                {{ item.createDate }}
                {{ item.description }}
                |
               学生姓名 {{ item.username }}
              </p>
            </vue3-seamless-scroll>
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-model="item.baojinShow" title="告警数据" width="300px" :modal="false"  :close-on-press-escape="false" :close-on-click-modal="false" @closed="closedDiago" v-for="(item,index) in currentSocketData" :key="index" :top="item.top">
      
        <el-scrollbar ref='scrollMenuRes' :max-height="300" wrap-style="overflow-x:hidden;" class="scrollb">
          <div class="gaojinby" >
        
                <div>{{ item.msg }}</div>
                <div>联系电话: {{ item.phone }}</div>
                <div>最近位置: {{ item.address ? item.address : "暂无数据" }}</div>
                <div>SOS号码: {{ item.contacts1 ? item.contacts1 : "暂无数据" }}</div>
                <div>SOS号码: {{ item.contacts2 ? item.contacts2 : "暂无数据" }}</div>
          
            </div>
        </el-scrollbar>
  
 

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="hanldeGoChuli(item)" type="success">前去处理</el-button>
        
        <el-button @click="handleConfirm(item)" type="danger">关闭</el-button>
        <!-- <el-icon @click="handleConfirm" color="#909399" size="20"><Close  /></el-icon> -->
      </div>
    </template>
</el-dialog>
<audio id="myAudio" controls ref="audio"  v-show="false">
  <source src="../../assets/screen/baojin.mp3" type="audio/mpeg">
  Your browser does not support the audio element.
</audio>
</div>
</template>

<script>
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
import AMapLoader from '@amap/amap-jsapi-loader';
import * as echarts from "echarts";
import {Close} from "@element-plus/icons-vue"
// import { capitals } from "./mock"
import dayjs from "dayjs";
import urls from "@/assets/api/env.js"
import {organizationList, schoolList, getWt, sosWaring, sosWaterAreaWaring, statistics, getUserById, waterAreaWaring, findUserDeviceLocation } from "@/assets/api/screen.js"
import wsMixin from '@/mixins/websocket.js'
import axios from 'axios'
import ScreenClock from './ScreenClock.vue'
export default {
  mixins: [wsMixin],
  components: {
    Vue3SeamlessScroll,
    Close,
    ScreenClock
  },
  data() {
    return {
      cityInfo:{
        province:"",
        city:""
      },
      tianqiData:[],
      timerVoices:undefined,
      voices:undefined,
      titleData: {
        siteName: "",
        username: ""
      },
      user: {
        id: ""
      },
      tongji: {
        "classCount": 0,
        "offlineCount": 0,
        "onlineCount": 0,
        "safetyGuardCount": 0,
        "schoolCount": 0,
        "totalCount": 0,
        "activeTotalCount":0,
      },
      zhifu:0,
      setHeight:0,
      baojinShow: false,
      currentSocketData:[],
      schoolList: [],
      currentSchool: {
        name: ""
      },
      fistPage:1, //1是第一次 其他是另外得
      map: null,
      mapOverlays: [], // 当前地图上的覆盖物，重新定位前先清理，防止切换学校后旧点位累积
      currentTianqi: {},
      waterList: [],
      sosList: [
        // " 2024-08-19 22:07:25SOS紧急求助!。|学生姓名：张毅",
      ],
    };
    {
    }
  },
  watch:{
    currentSchool(old,newd){
      if(newd.id){
        this.initGetData()
      }
     
    }
  },
  computed:{
    unit(){
      return this.titleData.userType=="school"?"（个）":"（个）";
    }
  },
  
  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.webSocketUrl = `wss://${urls.baseUrl}/api/pushMessage/`+this.user.id
  },
  
  mounted() {

    this.initMap();
    this.getzhifu()

    this.getUserType();
    this.initWebSocket(this.callback) //初始化
    window.addEventListener("resize", this.handleResize);

    // let i=0;
    // setInterval(()=>{
    //   let data= {
    //     "contacts1": "家人:20240815422",
    //     "msg": "测试终端22SOS呼叫"+i,
    //     "contacts2": "家人:20240815222",
    //     "address": "",
    //     "method": "sos",
    //     "phone": "0000",
    //     "imei":"865087069000157"
    // }
    // i++;
    //     this.callback(data)
    //   },10000)

  },
  beforeUnmount() {
    clearInterval(this.timerVoices);
    clearTimeout(this.timeoutNum);
    window.removeEventListener("resize", this.handleResize);
    ["leftChart", "rightChart"].forEach((id) => {
      const dom = document.getElementById(id);
      const inst = dom && echarts.getInstanceByDom(dom);
      if (inst) inst.dispose();
    });
    // mixin 里的 destroyed 钩子在 Vue3 不会触发，这里手动关闭 websocket，并置空以便再次进入页面时重连
    this.closeWebsocket();
    this.socket = null;
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
  },
  methods: {
    // sln
    getzhifu(){
      axios.get(`http://pay.mingyitech.cn:20011/student_mall/goods_order/queryPayCount?locationName=${JSON.parse(localStorage.getItem('user')).username}`,)
        .then(response => {
          // 处理响应数据
          // console.log(response.data,'slnnnnnnnnnnnnnnnn');
          this.zhifu = response.data.data.total_num
        })
        .catch(error => {
          // 处理错误情况
          console.error(error);
        });
    },
    formatName(item){
      if(this.titleData.userType=='school'){
        return item.name;
      }else{
        return item.siteName||item.alias||item.username
  

      }
    },
    handleSelectSchool(item){
      this.fistPage++;
      this.currentSchool=item;
    },
    rem(){
      // rem等比适配配置文件
      // 基准大小
      const baseSize = 14
      // 设置 rem 函数
      function setRem() {
          // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
          const scale = document.documentElement.clientWidth / 1920
          // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
          document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
      }
      // 初始化
      setRem()
      // 改变窗口大小时重新设置 rem
      window.onresize = function () {
          setRem()
      }
    },
    callback(data) {
    
      
     
      if (data.method == 'sos') {
        this.setHeight++;
        setTimeout(()=>{
          this.$refs.audio.play();
          this.scrollBottom();
        },3000)
     
        this.currentSocketData.push({...data,baojinShow:false,top:`${24-this.setHeight}%`});
        this.currentSocketData[this.currentSocketData.length-1].baojinShow=true;
        //  this.baojinShow = true;
       
          this.playVoice();
      }
    },
    closedDiago(){
      this.$refs.audio.currentTime = 0;
      this.setHeight--;
      this.currentSocketData.pop();
      this.$refs.audio.pause();
    },
    playVoice(){
      // 语音列表全局只需获取一次，缓存后后续报警直接播报，避免每次报警都 200ms 轮询 getVoices
      if (this.voices && this.voices.length) {
        this.initVoice({
          text: this.currentSocketData[ this.currentSocketData.length-1].msg,
          vol: 1,
          rate: 1
        })
        return
      }
      clearInterval(this.timerVoices);
      this.timerVoices = setInterval(() => {
          this.voices = window.speechSynthesis.getVoices()
          if (this.voices.length) {
              clearInterval(this.timerVoices)
              // 执行函数
              this.initVoice({
                text: this.currentSocketData[ this.currentSocketData.length-1].msg,
                vol: 1,
                rate: 1
              })
          }
      }, 200)
    },
    scrollBottom(){

        if (this.$refs.scrollMenuRes) {
            const container = this.$refs.scrollMenuRes.$el.querySelector('.el-scrollbar__wrap');
            container.style.scrollBehavior = 'smooth'; // 添加平滑滚动效果
            container.scrollTop = container.scrollHeight;
        }
    },
    initVoice(config) {
      window.speechSynthesis.cancel();//播报前建议调用取消的函数，如有正在播报的话音，播报会任务被塞进入队列，只有等上一个语音结束才会执行下一个语音
      //获取语音包
      let listArr = window.speechSynthesis.getVoices();
      listArr = listArr.filter(item => item.lang.indexOf('zh-') > -1);
      if (listArr.length == 0) {
        console.error('没有可用的中文语音!');
      }

      //实例化播报内容
      let instance = new SpeechSynthesisUtterance();
      instance.text = config.text || '轻轻敲醒沉睡的心灵，慢慢张开你的眼睛，看看忙碌的世界，是否依然孤独的转个不停！'; // 文字内容
      instance.lang = config.lang || "zh-CN"; // 使用的语言:中文
      instance.volume = config.vol || 1; // 声音音量：1
      instance.rate = config.rate || 1; // 语速：1
      instance.pitch = 1; // 音高：1
      window.speechSynthesis.speak(instance); // 播放
      instance.addEventListener("end", () => {
        console.log("播放完成")
      });// 监听播报完成状态，播完可以做些其它处理    
    },
    hanldeGoChuli(item) {
      item.baojinShow = false;
      this.currentSocketData.pop();
      this.setHeight--;
       //定义一个路径
      //  let imei=this.currentSocketData[this.currentSocketData.length-1].imei
       const href = this.$router.resolve({
        path: `/custMatchResults`,
        query: { imei:item.imei},
      }).href;
      //打开新的页面 到 href 这个页面
      window.open(href, "_blank");
    },
    handleConfirm(item) {
      item.baojinShow = false;
      this.setHeight--;
      this.currentSocketData.pop();
      this.$refs.audio.pause();
    },
    async getUserType(){
      const { data: data0 } = await getUserById({
        userId: this.user.id
      })
      this.titleData = data0.data;
      console.log(this.titleData,'sln666666')
      

      if(this.titleData.userType=="school"){
          const { data: data1 } = await schoolList({
            loginId: this.user.id
          })
          this.schoolList = data1.data;
          this.currentSchool = this.schoolList[0]?this.schoolList[0]:{
            name: ""
          };
      }else{
        const { data: data1 } = await organizationList({
            loginId: this.user.id
          })
          this.schoolList = data1.data;
          this.currentSchool = this.schoolList[0]?this.schoolList[0]:{
            name: ""
          };
        
      }
      this.initGetData();
    },
    async initGetData() {
   
     

      const { data: data2 } = await getWt({
        // loginId: this.user.id,
        cityName:this.titleData.address?this.titleData.address:"上海市"
      })
      this.currentTianqi = data2.data;

      const { data: data3 } = await sosWaring({
        loginId: this.user.id,
        schoolIdOrOrgId:this.fistPage==1?undefined:this.currentSchool.id,
        type: 8
      })
      this.warnChat = data3.data

      this.leftchart();

      const { data: data4 } = await sosWaterAreaWaring({
        loginId: this.user.id,
        schoolIdOrOrgId:this.fistPage==1?undefined:this.currentSchool.id,
        type: 8
      })
      this.sosList = (data4.data || []).slice(0, 30);

      const { data: data5 } = await sosWaterAreaWaring({
        loginId: this.user.id,
        schoolIdOrOrgId:this.fistPage==1?undefined:this.currentSchool.id,
        type: 19
      })
      this.waterList = (data5.data || []).slice(0, 30);


      const { data: data6 } = await statistics({
        schoolIdOrOrgId:this.fistPage==1?undefined:this.currentSchool.id,
        loginId: this.user.id
      })

      this.tongji = data6.data
      const { data: data7 } = await waterAreaWaring({
        schoolIdOrOrgId:this.fistPage==1?undefined:this.currentSchool.id,
        loginId: this.user.id,
        type: 19
      })
      this.rightChat = data7.data
      this.rightchart();

      const { data: data8 } = await findUserDeviceLocation({
        schoolIdOrOrgId:this.fistPage==1?undefined:this.currentSchool.id,
        userId: this.user.id
      })
      this.locationData = data8.data;
      this.location()
      // console.log(data)
    },
    location() {
      if (this.map && this.mapOverlays.length) {
        this.map.remove(this.mapOverlays);
        this.mapOverlays = [];
      }
      const points = (this.locationData || []).filter(i => i.lng && i.lat);
      // 大量点位时逐点创建 CircleMarker 会导致地图卡顿，改用 MassMarks 单 canvas 批量绘制
      if (points.length > 100) {
        this.renderMassMarks(points);
        return;
      }
      for (var i = 0; i < points.length; i += 1) {
        var center = [points[i].lng, points[i].lat];
        var circleMarker = new AMap.CircleMarker({
          center: center,
          radius: 5,//3D视图下，CircleMarker半径不要超过64px
          strokeColor: '#07FFE5',
          strokeWeight: 2,
          strokeOpacity: 0.5,
          fillColor: '#07FFE5',
          fillOpacity: 1,
          zIndex: 10,
          bubble: true,
          cursor: 'pointer',
          clickable: true
        })
        circleMarker.setMap(this.map)
        this.mapOverlays.push(circleMarker)
      }
    },
    renderMassMarks(points) {
      const mass = new AMap.MassMarks(
        points.map(i => ({ lnglat: [i.lng, i.lat] })),
        {
          opacity: 1,
          zIndex: 10,
          cursor: 'pointer',
          style: [{
            url: this.createCircleIcon(),
            size: new AMap.Size(10, 10),
            anchor: new AMap.Pixel(5, 5),
          }],
        }
      )
      mass.setMap(this.map)
      this.mapOverlays.push(mass)
    },
    // MassMarks 的样式需要图片 URL，这里用 canvas 运行时生成与 CircleMarker 同款的青色圆点，避免新增静态资源
    createCircleIcon() {
      const size = 20;
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = size;
      const ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, 5, 0, Math.PI * 2);
      ctx.globalAlpha = 0.5;
      ctx.lineWidth = 4;
      ctx.strokeStyle = '#07FFE5';
      ctx.stroke();
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#07FFE5';
      ctx.fill();
      return canvas.toDataURL();
    },
    initMap() {

      window._AMapSecurityConfig = {
        securityJsCode: "f2269481aca2ae2acdcc9267ed73aa7c",
      };
      AMapLoader.load({
        key: "4017c4d793ff24df61d0bc3f37ba10d1", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            resizeEnable: true, //是否监控地图容器尺寸变化
              mapStyle: "amap://styles/grey",
              zoom: 4,
          });

    
      //     var _this=this;
      // AMap.plugin('AMap.CitySearch', function () {
      //     var citySearch = new AMap.CitySearch()
        
      //     citySearch.getLocalCity(function (status, result) {
      //       console.log("🚀 ~ result:", result)
      //       console.log("🚀 ~ status:", status)
      //       _this.cityInfo=result;
      //       if (status === 'complete' && result.info === 'OK') {
      //         // 查询成功，result即为当前所在城市信息
      //                 // //加载天气查询插件
      //             AMap.plugin('AMap.Weather', function () {
      //               //创建天气查询实例
      //               var weather = new AMap.Weather();

      //               //执行实时天气信息查询
      //               console.log(result.city)
      //               weather.getForecast(result.city, function (err, data) {
      //                 console.log(data)
      //                 if(!err){
      //                   _this.tianqiData=data.forecasts;
      //                 }
      //               });
      //             });
      //       }
      //     })
      //   })
        })
        .catch((e) => {
          console.log(e);
        });
 


    
    },
    leftchart() {
      var chartDom = document.getElementById("leftChart");
      var myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "每日数据",

          left: "26%",
          top: "45%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
            align: "center",
          },
        },
        tooltip: {
          trigger: "item",
        },
        color: ["#FF756C", "#07FFE5"],
        legend: {
          data: ["SOS报警", "未报警"],
          orient: "vertical",
          right: 20,
          textStyle: {
            color: "#fft",
          },
        },
        series: [
          {
            type: "pie",
            center: ["34%", "50%"],
            radius: ["45%", "65%"],
            minAngle: 10,
            avoidLabelOverlap: true,
            roseType: "radius",
            hoverOffset: 15,
            label: {
              show: true,
              position: "outer",
              color: "inherit",
              formatter: "{c} 人",
            },
            data: [
              {
                name: "SOS报警",
                value: Number(this.warnChat.waringCount)<0?0:Number(this.warnChat.waringCount),
              },
              {
                name: "未报警",
                value: Number(this.warnChat.noWaringCount)<0?0:Number(this.warnChat.noWaringCount),
              },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
    rightchart() {
      var chartDom = document.getElementById("rightChart");
      var myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
      var option;
      let dataC1 = this.rightChat.map((item) => item.waterAreaCount);
      let xData = this.rightChat.map((item) => dayjs(item.day).format("MM/DD"));

      option = {
        backgroundColor: "transparent",
        grid: {
          top: 50,
          bottom: 20
        },
        tooltip: {
          trigger: 'axis',
        },

        legend: {
          data: ["每周数据"],
          orient: "vertical",
          right: 20,
          textStyle: {
            color: "#07FFE5",
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: true,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
          },
          data: xData,
        },
        yAxis: {
          type: "value",
          interval: 1,
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E5E5EF"
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#E5E5EF',
            show: true,
          }
        },
        series: [
          {
            name: "每周数据",
            type: "line",
            stack: "总量",
            smooth: true,
            // symbol: "none",
            showSymbol: false,
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#07FFE5',
                lineStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#07FFE5", // 0% 处的颜色
                      },
                      {
                        offset: 0.8,
                        color: "#07FFE5", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#07FFE5", // 100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                  width: 2,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
            },
            data: dataC1,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    handleResize() {
      ["leftChart", "rightChart"].forEach((id) => {
        const dom = document.getElementById(id);
        const inst = dom && echarts.getInstanceByDom(dom);
        if (inst) inst.resize();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#leftChart {
  width: 100%;
  height: 250px;
}

#rightChart {
  width: 100%;
  height: 250px;
}

.screen {
  background: url("../../assets/screen/bg.jpg");
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;

  .card {
    background: url("../../assets/screen/itembg3.png") no-repeat;
    background-size: 100%;

    .com-title {
      padding: 10px 30px;
      font-weight: 500;
    }
  }

  .header {
    background: url("../../assets/screen/headbg.png");
    height: 94px;
    background-size: 100% 100%;

    .title-h-1 {
      color: #fff;
      text-align: center;
      font-size: 32px;
      padding: 10px;
      font-weight: bold;
      font-style: italic;
    }

    .title-h-2 {
      color: #fff;
      text-align: center;
      font-size: 32px;

      font-weight: bold;
      font-style: italic;
      margin-top: -6px;
    }
  }

  .mainScreen {
    display: flex;

    color: #fff;
    padding: 50px;
    padding-top: 0;
    height: calc(100% - 120px);

    .left {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      width: 26%;
      overflow: hidden;

      .left-item-1 {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .left-item-1-i {
          width: 24%;
          background: url("../../assets/screen/itembg1.png") no-repeat;
          border-top-right-radius: 10px;
          border-bottom-left-radius: 10px;
          background-size: 100% 100%;
          padding: 6px 10px;
          margin-bottom: 20px;

          .left-item-1-num {
            font-weight: 500;
            text-align: center;
            font-size: 36px;
            color: #07ffe5;
            padding: 10px 0;

            &.active {
              color: #FF6C64;
            }
          }

          .des1 {
            font-size: 13px;
            font-weight: 500;
          }

          .des2 {
            font-size: 12px;
            color: #eee;
          }
        }
      }

      .left-item-2 {
        margin-bottom: 20px;
      }

      .left-item-3 {
        flex: 1;
        display: flex;
        flex-direction: column;
        .scrollData {
          flex: 1;
          padding: 10px;
          overflow: hidden;
          text-align: left;
          padding: 0;
     

          p {
            padding: 10px;
            font-size: 13px;
          }

          p:nth-of-type(2n + 2) {
            background: rgba(3, 110, 243, 0.2);
          }
        }
      }
    }

    .middle {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      width: 48%;

      .middle-item1 {
        display: flex;
        padding: 10px 30px;
        justify-content: space-between;

        .middle-title {
          padding: 6px 0;
          font-size: 13px;
        }

        .middle-item1-1 {
          background: url("../../assets/screen/middle1.png");
          background-size: 100% 100%;
          text-align: center;

          height: 120px;
          width: 42%;

          .m-content-1 {
            display: flex;
           align-items: center;
            justify-content: space-between;
            .tqicon{
              flex: 1;
              text-align: right;
              margin-top: 10px;
              img{
                width: 60px;
              }
            }
            .des{
              margin-top: 10px;
              font-size: 12px;
            }
          }
        }

        .middle-item1-2 {
          background: url("../../assets/screen/middle2.png");
          background-size: 100% 100%;
          text-align: center;
          height: 120px;
          width: 42%;

          .m-content-2 {
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: space-between;
            padding: 26px;
            font-weight: bold;
            font-size: 20px;

            img {
              width: 16px;
              height: 26px;
              margin-right: 20px;
            }
          }
        }
      }

      .middle-item2 {
        background: url("../../assets/screen/itembg2.png") no-repeat;
        background-size: 100%;
        margin: 10px 30px;
        flex: 1;
        margin-bottom: 55px;
        box-sizing: border-box;

        #container {

          height: 100%;
          width: 100%;
        }
      }
    }

    .right {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      width: 26%;
      overflow: hidden;
      .right-item-1 {
    
        .scrollData {
          padding: 10px;
          overflow: hidden;
          text-align: center;
          padding: 0;
          height: 180px;

          p {
            padding: 10px;
            font-size: 13px;
            background: rgba(3, 110, 243, 0.2);
            margin: 5px;

            &.active {
              background: #1980FF;
            }

          }

        }
      }

      .right-item-2 {
        margin: 20px 0;
      }

      .right-item-3 {
        display: flex;
        flex: 1;
        flex-direction: column;
        .scrollData {
          flex: 1;
          padding: 10px;
          overflow: hidden;
          text-align: left;
          padding: 0;
          height: 290px;

          p {
            padding: 10px;
            font-size: 13px;
          }

          p:nth-of-type(2n + 2) {
            background: rgba(3, 110, 243, 0.2);
          }
        }
      }
    }
  }
}

//弹窗
:deep(.el-dialog) {
  background: #0b2e55;

  .el-dialog__title {
    color: #fff;
  }
  .gaojinby {
      text-align: center;
      color: #fff;
      font-size: 16px;
      margin-bottom: 10px;
    }
  .dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;


    .el-button {
      width: 100px;
      margin-right: 30px;
    }
  }
}

//

// 报警红光靠独立遮罩层的 opacity 闪烁实现；用径向渐变代替 150px 模糊 box-shadow，光栅化开销更低
.screen::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(ellipse at center, transparent 45%, rgba(255, 0, 0, 0.5) 100%);
  opacity: 0;
}

.screen.activeBj::after {
  animation: alarmFlash 1.2s infinite alternate;
}

@keyframes alarmFlash {
  from {
    opacity: 0.9;
  }
  to {
    opacity: 0.2;
  }
}
  
</style>
